<template>
  <div>
    <v-overlay v-if="loading" opacity="0">
    </v-overlay>

    <v-card v-if="controller" max-width="550" width="100%" style="margin: auto" flat
      class="align-self-center text-center rounded-xl">
      <h1 class="font-weight-bold mb-2">
        {{ controller.authClass.loginStatus ? 'Iniciar sesión en SeleAI' : 'Registrarse en SeleAI' }}
      </h1>
      <p class="text-subtitle-1 grey--text text--darken-1">
        {{ controller.authClass.loginStatus ? subtitle : 'Crea una cuenta para comenzar a usar SeleAI' }}
      </p>

      <!-- LOGIN -->
      <v-sheet v-if="controller.authClass.loginStatus" class="pa-3">
        <form class="pa-5 pb-3" v-if="controller.authClass.loginStatus"
          @submit.prevent="onSignIn(loginForm.email, loginForm.password)">
          <v-text-field flat outlined color="primary" id="email" type="text" placeholder="Email"
            v-model="loginForm.email">
          </v-text-field>
          <v-text-field outlined flat color="primary" id="password" :append-icon="value ? mdiEye : mdiEyeOff"
            @click:append="() => (value = !value)" :type="value ? 'password' : 'text'" placeholder="Contraseña"
            v-model="loginForm.password">
          </v-text-field>

          <div class="pa-0 justify-end">
            <v-btn type="submit" right :disabled="!loginForm.email || !loginForm.password" width="100%" height="40"
              style="letter-spacing: normal; font-size: 16px" class="text-none text-center white--text"
              color="primary font-rubik" depressed :loading="loading">Iniciar Sesión
            </v-btn>
            <div class="text-start">
              <span v-if="errorMessage" class="red--text caption">{{ errorMessage }}</span>
            </div>
          </div>
        </form>

        <!-- GOOGLE LOGIN -->
        <div class="d-flex flex-column px-5 text-center justify-center align-center">
          <span class="font-rubik mt-6 font-weight-medium">O inicia sesión con:</span>
          <google-button :redirect="redirect"></google-button>
        </div>

        <!-- GO TO REGISTER -->
        <v-card-actions class="pt-12 justify-center">
          <v-card-title @click="controller.authClass.loginStatus = false" style="cursor: pointer"
            class="pa-0 subtitle-1 font-weight-medium green--text darken-5">
            Crear nueva cuenta
          </v-card-title>
        </v-card-actions>
      </v-sheet>

      <!-- REGISTER FORM -->
      <v-stepper v-model="controller.authClass.step" v-else flat>
        <div class="pa-3 pb-0 pt-2" style="margin: auto; border-radius: 10px">
          <v-stepper-items>
            <v-stepper-content step="1" class="pa-0">


              <!-- GOOGLE LOGIN -->
              <div class="d-flex flex-column px-5 text-center justify-center align-center align-center caption-text">
                <google-button :redirect="redirect"></google-button>
              </div>

              <div class="text-center my-4 d-flex align-center align-center caption" style="color: rgb(186 186 186)">
                <v-divider class="mx-5 my-auto"></v-divider> o
                <v-divider class="mx-5 my-auto"></v-divider>
              </div>

              <div style="min-height: 350px">
                <form class="px-5 pb-3" @submit.prevent="onRegister">
                  <v-row no-gutters class="pb-0 pt-2">
                    <v-col cols="12" class="pb-0">
                      <v-text-field flat outlined color="primary" id="name" type="text" placeholder="Nombre"
                        v-model="registerForm.name">
                      </v-text-field>
                    </v-col>
                  </v-row>

                  <v-text-field flat outlined id="email" color="primary" type="text" class="pt-1" placeholder="Email"
                    v-model="registerForm.email">
                  </v-text-field>

                  <v-text-field outlined flat color="primary" :append-icon="value ? mdiEye : mdiEyeOff"
                    @click:append="passVisibility()" :type="value ? 'password' : 'text'" placeholder="Contraseña"
                    v-model="registerForm.password1" class="pt-1">
                  </v-text-field>
                  <v-text-field outlined color="primary" flat :append-icon="value2 ? mdiEye : mdiEyeOff"
                    @click:append="passVisibility2()" :type="value2 ? 'password' : 'text'"
                    placeholder="Repetir contraseña" v-model="registerForm.password2" class="pt-1 pb-0">
                  </v-text-field>
                  <v-card-text class="red--text pa-0 text-end" v-if="registerForm.password1 !== registerForm.password2">
                    Las contraseñas deben coincidir
                  </v-card-text>

                  <v-checkbox v-model="checkbox">
                    <template v-slot:label>
                      <div>
                        Acepto los
                        <v-tooltip color="black">
                          <template v-slot:activator="{ on }">
                            <a target="_blank" href="https://sele.ai/terms" @click.stop v-on="on">
                              Términos
                            </a>
                          </template>
                        </v-tooltip>
                        y la
                        <v-tooltip color="black">
                          <template v-slot:activator="{ on }">
                            <a target="_blank" href="https://sele.ai/privacy" @click.stop v-on="on">
                              Política de Privacidad
                            </a>
                          </template>
                        </v-tooltip>
                      </div>
                    </template>
                  </v-checkbox>
                </form>
              </div>

              <v-container class="pa-5 pt-0 justify-end">
                <div class="text-start">
                  <span v-if="errorMessage" class="red--text caption">{{ errorMessage }}</span>
                </div>
                <v-btn type="submit" right @click="onRegister" :disabled="!canRegister" width="100%" height="40"
                  class="text-none text-center white--text subtitle-2" color="primary" depressed
                  :loading="loading">Registrarse
                </v-btn>
                <br>
                <v-btn type="submit" right @click="controller.authClass.loginStatus = true" width="100%" height="40"
                  text class="text-none text-center white--text subtitle-2 mt-4" color="grey lighten-2" depressed>
                  <span class="green--text text--darken-2">¿Ya tienes cuenta? Inicia sesión</span>
                </v-btn>
              </v-container>
            </v-stepper-content>

            <v-stepper-content step="2" class="pa-0">
              <div style="min-height: 350px">
                <v-card-title class="justify-start tit font-weight-bold title pt-0 pl-5">
                  Para tu conveniencia
                </v-card-title>

                <div class="pa-5 pt-2">
                  <v-text-field flat outlined color="primary" type="text" class="pa-0"
                    placeholder="Nombre de usuario (alias)" v-model="registerForm.nickname">
                  </v-text-field>

                  <v-autocomplete v-model="registerForm.institut" :items="instituts" clearable class="" hide-details
                    color="primary" hide-selected placeholder="¿En qué centro estudias?" outlined>
                  </v-autocomplete>

                  <v-autocomplete v-model="registerForm.branca" :items="branchOptions" clearable class="pt-7"
                    hide-details color="primary" hide-selected placeholder="¿Qué rama estás estudiando?" outlined>
                  </v-autocomplete>
                  <v-autocomplete v-model="registerForm.assignatures" :items="assignatures" chips multiple
                    class="pt-7 mb-12" single-line clearable hide-details color="primary" hide-selected item-text="name"
                    item-value="name" placeholder="Asignaturas específicas" outlined>
                    <template v-slot:selection="{ attr, on, item, selected }">
                      <v-chip v-bind="attr" :input-value="selected" color="green" class="white--text" v-on="on" close
                        @click:close="close(item.name)">
                        <span v-text="item.name"></span>
                      </v-chip>
                    </template>
                    <template v-slot:item="{ item }">
                      <v-list-item-action>
                        <v-icon color="green">{{ item.icon }}</v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-medium">
                          {{ item.name }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </div>
              </div>

              <v-container class="pr-5 pl-5 pt-0 pb-0 justify-end">
                <v-btn type="submit" right @click="addAssignatura" :disabled="somhi" width="100%" height="40"
                  class="text-none text-center white--text subtitle-2 mt-12" color="primary" depressed>¡Empecemos!
                </v-btn>
                <br>
                <v-btn type="submit" right @click="toLater" width="100%" height="40" outlined
                  class="text-none text-center white--text subtitle-2 mt-4 mb-5" color="grey lighten-2" depressed>
                  <span class="green--text text--darken-2">Más tarde</span>
                </v-btn>
              </v-container>
            </v-stepper-content>
          </v-stepper-items>
        </div>
      </v-stepper>
    </v-card>

    <!-- Reset password dialog -->
    <v-dialog v-model="resetPass" max-width="600">
      <v-card v-if="loginForm && loginForm.email" width="600" class="py-6 px-10">
        <h1>Confirma tu cuenta</h1>
        <p>Acabamos de enviar un correo a <span style="font-style: italic">{{ loginForm.email }}</span> para confirmar
          que
          eres tú.</p>
        <p>El mensaje podría llegar a tu carpeta de Spam.</p>
        <p>Introduce el código:</p>
        <v-text-field v-model="resetCodePass" solo class="mx-auto px-auto" style="max-width: 240px"></v-text-field>

        <v-card-actions class="d-flex flex-column text-center justify-center">
          <span v-if="errorMessageCodePass" class="red--text mx-auto caption mb-10">El código es incorrecto, te quedan
            {{
              confirmPassTimes }} intentos...</span>
          <v-btn color="primary" depressed :disabled="!resetCodePass" width="140" @click="confirmPassCode"
            class="text-none mx-auto tit" large>Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mdiEye } from '/src/assets/mdi.json'
import { mdiEyeOff } from '/src/assets/mdi.json'
import Loader from '../../../../components/VLoader'
import controller from "@/store/Controller";
import GoogleButton from "./GoogleButton.vue";
import cookies from "../../../../modules/cookies/cookieController";

export default {
  components: {
    GoogleButton,
    pulseLoader: Loader
  },
  props: {
    redirect: {
      type: String,
      default: "/start-2"
    },
    loginStatus: {
      type: Boolean,
      default: true
    },
    dialog: {
      type: Boolean,
      default: true
    },
    subtitle: {
      type: String,
      default: 'Ingresa tus credenciales para acceder a tu cuenta'
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },
  mounted() {
    if (this.getUser) {
      this.afterLog()
    }

    this.controller.authClass.loginStatus = this.loginStatus

    // Initialize branch options
    this.branchOptions = [
      'Ciencias y Tecnología',
      'Sociales y Humanidades',
      'Artes',
      'Múltiples ramas...'
    ]
  },
  data() {
    return {
      mdiEye: mdiEye,
      mdiEyeOff: mdiEyeOff,
      prevRoute: null,
      resetCodePass: null,
      resetCodePassReal: null,
      controller: controller,
      value: true,
      value2: true,
      loginForm: {
        email: '',
        password: ''
      },
      registerForm: {
        name: '',
        email: '',
        password1: '',
        password2: '',
        branca: '',
        assignatures: [],
        nickname: '',
        institut: ''
      },
      errors: null,
      showErrors: false,
      local_dialog: null,
      userId: null,
      invalidEmail: false,
      checkbox: false,
      login: false,
      addedAssig: false,
      instituts: null,
      loading: false,
      activated: false,
      resetPass: false,
      errorMessage: null,
      confirmPassTimes: 5,
      errorMessageCodePass: false,
      branchOptions: []
    }
  },
  computed: {
    getUser() {
      return this.$root.currentUser.value
    },
    prevRoutePath() {
      return this.prevRoute ? this.prevRoute.path : '/'
    },
    isMobile: function () {
      return this.$vuetify.breakpoint.name === 'sm' || this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name === 'md'
    },
    checkDoublePass: function () {
      return (this.registerForm.password1 === this.registerForm.password2) && this.registerForm.password2.length > 6
    },
    getInitial() {
      return this.registerForm.name.substring(0, 1)
    },
    getRandomColor() {
      return '#' + Math.floor(Math.random() * 16777215).toString(16)
    },
    assignatures() {
      return null
    },
    canRegister() {
      return this.checkDoublePass &&
        this.checkbox &&
        this.registerForm.name !== '' &&
        (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.registerForm.email))
    },
    somhi() {
      if (!this.registerForm.branca ||
        !this.registerForm.assignatures ||
        !this.registerForm.institut ||
        !this.registerForm.nickname ||
        this.registerForm.assignatures.length === 0) {
        return true
      }
      return false
    },
    isUserInfo() {
      return (this.getUser.branca && this.getUser.assignatures && this.getUser.nickname && this.getUser.institut)
    }
  },
  methods: {
    toLater() {
      this.local_dialog = false
      this.$router.push({ path: '/app', query: { ...this.$route.query } })
    },
    async confirmPassCode() {
      if (this.confirmPassTimes <= 0) this.resetPass = false;
      if (this.resetCodePassReal === this.resetCodePass) {
        this.errorMessageCodePass = false;
        await this.updatePassword();
      } else {
        this.errorMessageCodePass = true;
        this.confirmPassTimes--;
      }
    },
    async updatePassword() {
      try {
        await this.axios.post("/profile/password", {
          user_id: this.userId,
          old_password: this.loginForm.oldCodePass,
          new_password: this.loginForm.password
        })
        await this.onSignIn(this.loginForm.email, this.loginForm.password);
      } catch (err) {
      } finally {
        this.resetPass = false;
      }
    },
    async onSignIn(email, password) {
      this.loading = true
      try {
        const res = await this.axios.post('/login', {
          user_email: email,
          user_password: password
        })

        if (res.data.user) {
          this.$root.currentUser.value = res.data.user
          this.$root.token.value = res.data.token

          // Configurar cookies como en main.ts
          await this.$cookies.set("user", res.data.user)
          this.$root.currentUser.userId = res.data.user.user_id
          await this.$cookies.set("token", res.data.token)

          console.log("res.data.user", res.data.user)
          console.log("res.data.token", res.data.token)

          cookies.user.setValues(res.data.user)


          this.$root.currentUser.premium = res.data.user.premium ? res.data.user.premium : false;
          // this.$root.currentUser.hasInfo = res.data.user.hasInfo ? res.data.user.hasInfo : false;


          console.log("res.data.user.user_info && Object.keys(res.data.user.user_info).length > 0", res.data.user.user_info && Object.keys(res.data.user.user_info).length > 0)

          const redirect = this.$route.query.redirect || this.redirect


          if (res.data.user.user_info && Object.keys(res.data.user.user_info).length > 0) {
            if (!redirect) {
              this.$router.push({
                path: "/app",
                query: { ...this.$route.query }
              });
            } else {
              if (this.$route.path === redirect) {
                this.local_dialog = false
              } else {
              this.$router.push({
                path: redirect,
                  query: { ...this.$route.query }
                });
              }
            }
          } else {
            this.$router.push({
              path: "/start-2",
              query: { ...this.$route.query }
            });
          }
          this.login = true;
          this.local_dialog = false
        }
      } catch (err) {
        if (err && err.response && err.response.status === 401) this.errorMessage = err.response.data.message
        else if (err && err.response && err.response.status === 500) {
          this.resetPass = true;
          this.resetCodePassReal = err.response.data.code;
          this.userId = err.response.data.userId;
        }
      } finally {
        this.loading = false
        this.$emit('update:dialog', false)
      }
    },
    async addAssignatura() {
      this.loading = true
      try {
        // await this.$store.commit('addAssignatura', {
        //   branca: this.registerForm.branca,
        //   assignatures: this.registerForm.assignatures,
        //   nickname: this.registerForm.nickname,
        //   institut: this.registerForm.institut
        // })
      } finally {
        this.local_dialog = false
        setTimeout(() => {
          this.$router.push({ path: '/selectivitat' })
          this.loading = false
          this.registerForm = {
            name: '',
            email: '',
            password1: '',
            password2: '',
            branca: '',
            assignatures: [],
            nickname: '',
            institut: ''
          }
        }, 700)
      }
    },
    async onRegister() {
      this.loading = true
      const user = {
        user_name: this.registerForm.name,
        user_email: this.registerForm.email,
        user_password: this.registerForm.password1
      }

      try {
        const res = await this.axios.post('/register', user);
        await this.onSignIn(this.registerForm.email, this.registerForm.password1);
      } catch (err) {
        if (err && err.response && err.response.status === 401) this.errorMessage = err.response.data.message
      } finally {
        this.loading = false;
        this.$emit('update:dialog', false)
      }
    },
    passVisibility() {
      this.value = !this.value
      if (!this.value2) this.value2 = true
    },
    passVisibility2() {
      this.value2 = !this.value2
      if (!this.value) this.value = true
    },
    close(name) {
      const array = this.registerForm.assignatures
      const index = array.indexOf(name)
      if (index >= 0) array.splice(index, 1)
    },
    async afterLog() {
      this.local_dialog = false
      const redirect = this.$route.query.redirect || this.redirect
      if (redirect) {
        await this.$router.push({
          path: redirect,
          query: { ...this.$route.query }
        })
      } else
        await this.$router.push({
          path: '/app',
          query: { ...this.$route.query }
        })
    }
  },
  watch: {
    'registerForm.password1'(val) {
      if (val && this.registerForm.email) {
        if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.registerForm.email)) && val !== '') {
          this.invalidEmail = true
        } else {
          this.invalidEmail = false
        }
      }
    },
    local_dialog(val) {
      if (!val) this.loading = false
      this.$emit('update:dialog', val)
    },
    '$route.query': {
      handler(val) {
        console.log("query", val)
        if (val.loginStatus == "false") {
          setTimeout(() => {

            this.controller.authClass.loginStatus = false
          }, 10)
        }

        if (val.from == "google" && val.user_id) {
          this.$root.currentUser.userId = val.user_id
        }
      },
      immediate: true
    }
  }
}
</script>

<style>
.center {
  width: 50%;
  margin: auto;
}

/* Estilos actualizados para botones y campos de texto */
.v-btn--outlined {
  border: 2px solid currentColor !important;
  border-radius: 12px !important;
  font-weight: 500 !important;
  letter-spacing: 0.5px !important;
  transition: all 0.3s ease-in-out;
}

.v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 500 !important;
  box-shadow: none !important;
  transition: all 0.2s ease-in-out;
}

.v-text-field--outlined fieldset {
  border-collapse: collapse;
  border-color: rgba(0, 0, 0, 0.15);
  border-style: solid;
  border-width: 2px !important;
  border-radius: 12px !important;
  transition: all 0.2s ease;
}

.v-text-field__details,
.v-messages {
  min-height: fit-content;
  height: fit-content;
  display: none;
}

.v-text-field--outlined:hover fieldset {
  border-color: rgba(0, 0, 0, 0.3);
}

.tit {
  color: #333333;
  font-weight: 600;
  font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, Ubuntu, sans-serif !important;
}

/* Estilos adicionales para mejorar la apariencia */
.v-card {
  transition: all 0.3s ease;
  border-radius: 16px !important;
  overflow: hidden;
}

.v-stepper {
  box-shadow: none !important;
  background-color: transparent !important;
}

.v-card-title,
.v-card-subtitle {
  font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, Ubuntu, sans-serif !important;
}

.v-chip {
  font-weight: 500 !important;
  border-radius: 8px !important;
}

h1 {
  font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, Ubuntu, sans-serif !important;
  font-size: 2rem !important;
  color: #333;
  margin-top: 1rem;
}

p {
  font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, Ubuntu, sans-serif !important;
  line-height: 1.6;
}

.v-checkbox {
  margin-top: 8px !important;
}

/* Agregando brillo en hover a campos interactivos */
.v-text-field:hover,
.v-select:hover,
.v-autocomplete:hover {
  opacity: 0.9;
}
</style>
